import {
  CommonLayoutPropsOption,
  GetCommonLayout,
  LayoutName,
} from '@/types/other';
import { ReactElement } from 'react';
import withCommonLayoutProps from './withCommonLayout';
import DashboardLayout from '@/components/layouts/dashboardLayout';

import AuthLayout from '@/components/layouts/authLayout';
import IndexLayout from '@/components/layouts/indexLayout';
import Layout from '@/components/layouts/layout';
import SettingsLayout from '@/components/layouts/settingsLayout';
import ProcessLayout from '@/components/layouts/processLayout';
import ProcessLayoutV2 from '@/components/layouts/processLayoutV2';
import LayoutNoFooter from '@/components/layouts/layoutNoFooter';

const layoutMap: {
  [key in LayoutName]?: (
    page: ReactElement,
    props: CommonLayoutPropsOption
  ) => ReactElement;
} = {
  auth: (page, props) => withCommonLayoutProps(page, props, AuthLayout),
  dashboard: (page, props) =>
    withCommonLayoutProps(page, props, DashboardLayout),
  index: (page, props) => withCommonLayoutProps(page, props, IndexLayout),
  settings: (page, props) => withCommonLayoutProps(page, props, SettingsLayout),
  process: (page, props) => withCommonLayoutProps(page, props, ProcessLayout),
  processv2: (page, props) =>
    withCommonLayoutProps(page, props, ProcessLayoutV2),
  noFooter: (page, props) => withCommonLayoutProps(page, props, LayoutNoFooter),
  default: (page, props) => withCommonLayoutProps(page, props, Layout),
};

const getCommonLayout: GetCommonLayout = (layoutName) => {
  const layout = layoutMap[`${layoutName}`] || layoutMap.default!;
  return layout;
};

export default getCommonLayout;
